/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Min_Event_Lines_LabelInputs */

const en_style_guide_manager_min_event_lines_label = /** @type {(inputs: Style_Guide_Manager_Min_Event_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimum Event Lines`)
};

const fr_style_guide_manager_min_event_lines_label = /** @type {(inputs: Style_Guide_Manager_Min_Event_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lignes minimum par evenement`)
};

const de_style_guide_manager_min_event_lines_label = /** @type {(inputs: Style_Guide_Manager_Min_Event_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mindestanzahl an Ereigniszeilen`)
};

const it_style_guide_manager_min_event_lines_label = /** @type {(inputs: Style_Guide_Manager_Min_Event_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linee di eventi minimi`)
};

const ru_style_guide_manager_min_event_lines_label = /** @type {(inputs: Style_Guide_Manager_Min_Event_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Минимальное количество линий событий`)
};

const es_style_guide_manager_min_event_lines_label = /** @type {(inputs: Style_Guide_Manager_Min_Event_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Líneas mínimas de eventos`)
};

const zh_cn2_style_guide_manager_min_event_lines_label = /** @type {(inputs: Style_Guide_Manager_Min_Event_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最低事件线`)
};

const ja_style_guide_manager_min_event_lines_label = /** @type {(inputs: Style_Guide_Manager_Min_Event_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最小イベントライン`)
};

const hi_style_guide_manager_min_event_lines_label = /** @type {(inputs: Style_Guide_Manager_Min_Event_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`न्यूनतम घटना रेखाएँ`)
};

const pt_pt2_style_guide_manager_min_event_lines_label = /** @type {(inputs: Style_Guide_Manager_Min_Event_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linhas mínimas de eventos`)
};

/**
* | output |
* | --- |
* | "Minimum Event Lines" |
*
* @param {Style_Guide_Manager_Min_Event_Lines_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_min_event_lines_label = /** @type {((inputs?: Style_Guide_Manager_Min_Event_Lines_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Min_Event_Lines_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_min_event_lines_label(inputs)
	if (locale === "de") return de_style_guide_manager_min_event_lines_label(inputs)
	if (locale === "it") return it_style_guide_manager_min_event_lines_label(inputs)
	if (locale === "ru") return ru_style_guide_manager_min_event_lines_label(inputs)
	if (locale === "es") return es_style_guide_manager_min_event_lines_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_min_event_lines_label(inputs)
	if (locale === "ja") return ja_style_guide_manager_min_event_lines_label(inputs)
	if (locale === "hi") return hi_style_guide_manager_min_event_lines_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_min_event_lines_label(inputs)
	return en_style_guide_manager_min_event_lines_label(inputs)
});